import * as auth from "./auth";
import * as orders from "./orders";
import * as navigation from './navigation'
import * as notifications from './notifications'
export default {
  ...auth,
  ...orders,
  ...navigation,
  ...notifications,
};
